import { MoreVert } from "@mui/icons-material";
import { Button, Popper, Paper, ClickAwayListener } from "@mui/material";
import React, { useState, PropsWithChildren } from "react";

function MoreComponent(props: PropsWithChildren & {elevation?: number}) {
  const [anchorEl, setAnchorEl] = useState<(EventTarget & HTMLButtonElement) | null>(null);
  const open = Boolean(anchorEl);

  const handleClose = () => {
    setAnchorEl(null);
  };

  const wrappedChildren = React.Children.map(props.children, (child) =>{
    if (!React.isValidElement(child)) return child;

    const element = child as React.ReactElement<any>;

    return React.cloneElement(element, {
      onClick: (...args: any[]) => {
        element.props.onClick?.(...args);
        handleClose();
      },
    });
  });

  return (
    <>
      <Button onClick={(e) => setAnchorEl(anchorEl ? null : e.currentTarget)}>
        <MoreVert />
      </Button>
      <Popper open={open} anchorEl={anchorEl} placement="bottom-start">
        <ClickAwayListener onClickAway={handleClose}>
          <Paper sx={{ padding: 1 }} elevation={props?.elevation ?? 2}>
            {wrappedChildren}
          </Paper>
        </ClickAwayListener>
      </Popper>
    </>
  );
}

export default MoreComponent